import { UPDATE_EVENT_PREFIX } from "./events.js";
import { throttling } from "./utils/throttling.js";
const dispatchVariableUpdateEvent = (variableName, param)=>{
    let { mainElement } = param;
    //const previous = oVarsVal[variableName];
    mainElement.dispatchEvent(new CustomEvent(`${UPDATE_EVENT_PREFIX}${variableName}`, {
        detail: {}
    }));
};
const createComputedFactory = (param, param1)=>{
    let { mainElement, varsVal } = param;
    let { variable, vars: varsFn } = param1;
    return (vars, calculate, suffix, doThrottling)=>{
        let updater;
        const variableNames = vars.map((c)=>typeof c === "function" ? c(false) : undefined);
        // Throttle the "expensive" calculation to avoid multiple executions when
        // e.g. running update of `createVarFactory#vars()`.
        const doCalc = ()=>calculate(variableNames.map((v)=>varsVal.get(v)));
        const throttleCalc = throttling(doThrottling || 0, ()=>updater(doCalc()));
        // Attach to update events
        for (const variableName of variableNames){
            mainElement.addEventListener(`${UPDATE_EVENT_PREFIX}${variableName}`, throttleCalc);
        }
        // Write the variable once
        const calculated = doCalc();
        const createdVar = typeof calculated === "object" && !Array.isArray(calculated) ? (()=>{
            const r = varsFn(calculated, undefined);
            [, updater] = r;
            return r[0];
        })() : (()=>{
            const r = variable(calculated, undefined, suffix);
            updater = r.update;
            return r;
        })();
        // Modify updater functionality to not take any parameter and do a recalculate
        createdVar.update = ()=>throttleCalc();
        return createdVar;
    };
};
export { dispatchVariableUpdateEvent, createComputedFactory };
